import { Gauge, Cpu, RefreshCcw, ScanSearch, Crosshair, MessageCircle } from "lucide-react";
import { TiltCard } from "./TiltCard";
import { Reveal, SectionHeading } from "./Reveal";
import { SERVICES, waLink } from "../lib/site";

const ICONS = { Gauge, Cpu, RefreshCcw, ScanSearch, Crosshair };

export const ServicesGrid = () => (
  <section
    id="services"
    data-testid="services-section"
    className="bg-[#090B10] py-20 sm:py-28 relative overflow-hidden"
  >
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_50%_40%_at_50%_0%,rgba(230,57,70,0.07),transparent)]" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        eyebrow="Services"
        title="حلول متكاملة لحساسات الكفرات"
        desc="خمس خدمات متخصصة تغطي كل ما يتعلق بحساسات ضغط الإطارات — كل الاستفسارات وطلبات الأسعار عبر واتساب."
      />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.id} delay={i * 0.08} className={i === 0 ? "sm:col-span-2 lg:col-span-1" : ""}>
              <TiltCard
                testId={`service-card-${i + 1}`}
                className="metal-card rounded-3xl p-7 h-full hover:border-red-500/40 transition-colors duration-300 group"
              >
                <div className="w-14 h-14 rounded-2xl bg-red-600/10 border border-red-500/25 flex items-center justify-center mb-6 group-hover:bg-red-600/20 transition-colors">
                  <Icon size={26} className="text-red-500" />
                </div>
                <h3 className="font-display text-lg sm:text-xl font-bold text-white mb-3">
                  {s.title}
                </h3>
                <p className="text-sm text-slate-400 leading-relaxed mb-7">{s.desc}</p>
                <a
                  href={waLink(`السلام عليكم، أرغب في الاستفسار عن خدمة: ${s.title}`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`service-whatsapp-btn-${i + 1}`}
                  className="inline-flex items-center gap-2 text-sm font-semibold text-emerald-400 hover:text-emerald-300 border border-emerald-500/30 hover:border-emerald-400/60 rounded-full px-5 py-2.5 transition-all active:scale-[0.97]"
                >
                  <MessageCircle size={16} />
                  استفسر عبر واتساب
                </a>
              </TiltCard>
            </Reveal>
          );
        })}
        <Reveal delay={0.4}>
          <div className="rounded-3xl border border-dashed border-white/15 p-7 h-full flex flex-col justify-center bg-white/[0.02]">
            <h3 className="font-display text-lg font-bold text-white mb-3">
              غير متأكد من الخدمة المطلوبة؟
            </h3>
            <p className="text-sm text-slate-400 leading-relaxed mb-5">
              أرسل لنا بيانات سيارتك ونوضح لك الخدمة المناسبة قبل أي طلب.
            </p>
            <a
              href="#finder"
              data-testid="service-book-whatsapp-btn"
              className="inline-flex items-center gap-2 text-sm font-bold text-white bg-gradient-to-r from-red-600 to-red-700 hover:from-red-500 hover:to-red-600 rounded-full px-5 py-2.5 w-fit shadow-[0_4px_24px_rgba(220,38,38,0.35)] transition-all active:scale-[0.97]"
            >
              اعرف الحساس المناسب
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
